import { FOXIA_BLOG_CATEGORIES_API } from "@/api/api-endpoint";
import type { IFilter } from "@/interfaces/common/BaseEntity";
import type { FoxiaBlogCategory } from "@/interfaces/foxia-blog.interface";
import type { CountResponse } from "@/core/network/NodeResponse";
import { request, type RequestCancellation } from "@/repositories/repositoryRequest";

class FoxiaBlogCategoriesRepo {
  getListBlogCategories(
    filter?: IFilter,
    cancelToken?: RequestCancellation,
  ) {
    const path = FOXIA_BLOG_CATEGORIES_API.FOXIA_BLOG_CATEGORIES();
    return request<CountResponse<FoxiaBlogCategory[]>>(
      {
        method: "GET",
        url: path,
        params: filter,
      },
      cancelToken,
    );
  }

  getBlogCategoryDetail(id: number | string, cancelToken?: RequestCancellation) {
    const path = FOXIA_BLOG_CATEGORIES_API.FOXIA_BLOG_CATEGORIES(id);
    return request<FoxiaBlogCategory>(
      {
        method: "GET",
        url: path,
      },
      cancelToken,
    );
  }

  createBlogCategory(
    data: FoxiaBlogCategory,
    cancelToken?: RequestCancellation,
  ) {
    const path = FOXIA_BLOG_CATEGORIES_API.FOXIA_BLOG_CATEGORIES();
    return request<FoxiaBlogCategory>(
      {
        method: "POST",
        url: path,
        data,
      },
      cancelToken,
    );
  }

  updateBlogCategory(
    id: number | string,
    data: FoxiaBlogCategory,
    cancelToken?: RequestCancellation,
  ) {
    const path = FOXIA_BLOG_CATEGORIES_API.FOXIA_BLOG_CATEGORIES(id);
    return request<FoxiaBlogCategory>(
      {
        method: "PUT",
        url: path,
        data,
      },
      cancelToken,
    );
  }

  deleteBlogCategory(id: number | string, cancelToken?: RequestCancellation) {
    const path = FOXIA_BLOG_CATEGORIES_API.FOXIA_BLOG_CATEGORIES(id);
    return request<unknown>(
      {
        method: "DELETE",
        url: path,
      },
      cancelToken,
    );
  }
}

export default new FoxiaBlogCategoriesRepo();
